<template>
	<div>
		<div :key="variable.name"
		     :variable="variable.name.replace(/[{}]/g,'')"
		     class="var-item"
		     v-for="variable in $store.getters.combinedVariables"
		     v-html="variable.name.replace(/[{}]/g,'')"
		     v-show="variable.name.indexOf(filter) > -1"
		></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				filter: ''
			}
		},
		computed: {},
		methods: {},
		components: {}
	}
</script>

<style lang="less">

</style>
